const menu = [{
    items: [{
        class: '--arena-linear-gradient',
        label: 'Arena',
        href: '#!/arena',
        svg: 'arena'
    }, {
        label: 'Overview',
        href: '#!/overview',
        svg: 'overview'
    }, {
        label: 'World',
        href: '#!/map',
        svg: 'world'
    }]
}, {
    class: 'p',
    items: [{
        label: 'Documentation',
        href: 'http://docs.screeps.com',
        target: '_blank',
        svg: 'documentation'
    }, {
        label: 'Training',
        routerLink: '/sim',
        svg: 'training'
    }, {
        conditions: ['isNotNw', 'isNotPtr'],
        label: 'Public Test Realm',
        href: 'http://docs.screeps.com/ptr.html',
        target: '_blank',
        svg: 'ptr'
    }, {
        id: 'menu-item-messages',
        class: '--bottom-auto',
        label: 'Messages',
        href: '#!/messages',
        svg: 'message'
    }, {
        conditions: ['isNw'],
        label: 'Change server',
        routerLink: '/nw-menu',
        svg: 'change-server'
    }]
}, {
    class: 'p',
    items: [{
        id: 'menu-item-news',
        label: 'News',
        href: 'https://store.steampowered.com/news/app/464350',
        target: '_blank',
        svg: 'blog'
    }, {
    //     label: 'Slack',
    //     href: 'https://chat.screeps.com/',
    //     target: '_blank',
    //     svg: 'slack'
    // }, {
        label: 'Discord',
        href: 'https://chat.screeps.com',
        target: '_blank',
        svg: 'discord'
    }, {
        label: 'GitHub',
        href: 'https://github.com/screeps/screeps',
        target: '_blank',
        svg: 'github'
    }, {
        label: 'X',
        href: 'https://twitter.com/ScreepsGame',
        target: '_blank',
        svg: 'twitter'
    }, {
        label: 'Reddit',
        href: 'https://reddit.com/r/screeps',
        target: '_blank',
        svg: 'reddit'
    }, {
        label: 'Facebook',
        href: 'https://facebook.com/ScreepsGame',
        target: '_blank',
        svg: 'facebook'
    }]
}, {
    class: 'p --flex-grow',
    items: [{
        label: 'Report a problem',
        href: 'mailto:contact@screeps.com',
        target: '_blank',
        svg: 'report-problem'
    }]
}];

export default menu;
